import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http"
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadfileService {
  @Output()
  logo: EventEmitter<any> = new EventEmitter(true);
  getDetails: EventEmitter<any> = new EventEmitter(true);
  getSectionName: EventEmitter<any> = new EventEmitter(true);
  uploadedFiles: EventEmitter<any> = new EventEmitter(true);
  dataArrayUploadFile: EventEmitter<any> = new EventEmitter(true);
  uploadedFilesArray: EventEmitter<any> = new EventEmitter(true);
  dataUploadFileArray: EventEmitter<any> = new EventEmitter(true);
  partnerLogo: EventEmitter<any> = new EventEmitter(true);
  locationCard: EventEmitter<any> = new EventEmitter(true);
  availableFiles: EventEmitter<any> = new EventEmitter(true);
  selectFileCard: EventEmitter<any> = new EventEmitter(true);
  partnerCard: EventEmitter<any> = new EventEmitter(true);
  partnerLogoUpdated: EventEmitter<any> = new EventEmitter(true);
  updatedCustDetails: EventEmitter<any> = new EventEmitter(true);
  locationEmit: EventEmitter<any> = new EventEmitter(true);
  partnerLogoFileData: EventEmitter<any> = new EventEmitter(true);
  totalCost: EventEmitter<any> = new EventEmitter(true);
  locationValue: EventEmitter<any> = new EventEmitter(true);
  locationId: EventEmitter<any> = new EventEmitter(true);
  uploadFileConfig: EventEmitter<any> = new EventEmitter(true);
  howToData: EventEmitter<any> = new EventEmitter(true);
  showToggleError: EventEmitter<any> = new EventEmitter(true);
  anyFileSelected: EventEmitter<any> = new EventEmitter(true);
  disableSelectButton: EventEmitter<any> = new EventEmitter(true);
  openMatdialog: EventEmitter<any> = new EventEmitter(true);
  isResetButton: EventEmitter<any> = new EventEmitter(true);


  baseURL: any = environment.baseURL;
  header: any;
  private uploadUrlSubject = new BehaviorSubject<any>('');
  uploadUrl$ = this.uploadUrlSubject.asObservable();
  private isNewLogoUploadSubject = new BehaviorSubject<boolean>(false);
  isNewLogoUpload$ = this.isNewLogoUploadSubject.asObservable();

  constructor(private http: HttpClient) {
    this.header = new HttpHeaders({
      // "Content-Type": "application/json",
      // "tier": localStorage.getItem("Tier"), 
      // "tier": "standard", 
      "apiKey": environment.apiKey
    });
  }

  uploadFileAPICall(values: any): Observable<any> {
    let newHeader = this.commonHeader();
    return this.http.post(this.baseURL + 'signedUrlsV2', values, {
      headers: newHeader
    });
  }
  
  signedURLAPICall(file: any, signedURL: any): Observable<any> {
    let newHeader = this.commonHeader();
    newHeader = newHeader.append('x-amz-server-side-encryption', 'AES256')
    return this.http.put(signedURL , file, {
      headers: newHeader
    }
    );
  }

  confirmFileUploadAPICall(values: any): Observable<any> {
    let newHeader = this.commonHeader();
    return this.http.post(this.baseURL + 'confirmFileUpload', values, {
      headers: newHeader
    }
    );
  }

  domainInfoAPICall(): Observable<any> {
    return this.http.get(this.baseURL + 'domainInfo', {
      headers: this.header
    });
  }

  commonHeader(){
    let newHeader = this.header;
    let tier = localStorage.getItem('Tier');
    newHeader = newHeader.append('tier', tier);
    return newHeader
  }

  setPartnerLogoUrl(uploadUrl: any) {
    this.uploadUrlSubject.next(uploadUrl);
  }

  clearPartnerLogoUrl(): void {
    this.uploadUrlSubject.next('');
  }

  setIsNewLogoUpload(uploadLogo: any) {
    this.isNewLogoUploadSubject.next(uploadLogo);
  }
}

